import { useEffect, useState } from 'react'
import { DownloadDataButton } from '../DownloadDataButton'

export function Header() {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const formattedTime = time.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })

  const formattedDate = time.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  })

  return (
    <header className="flex items-center justify-between px-6 py-4 border-b border-white/[0.06] bg-[#0b0c0d]">
      <div className="flex items-center gap-4">
        <a href="https://www.theseus.us/" target="_blank" rel="noopener noreferrer" className="text-primary font-bold text-2xl hover:opacity-80 transition-opacity">
          THESEUS
        </a>
        <div className="h-5 w-px bg-white/[0.15]" />
        <h1 className="text-lg font-medium text-white/90">Operations Dashboard</h1>
      </div>
      <div className="flex items-center gap-4">
        <DownloadDataButton />
        <div className="flex flex-col items-end">
          <div className="text-2xl font-semibold text-white tabular-nums">{formattedTime}</div>
          <div className="text-sm text-white/70">{formattedDate}</div>
        </div>
      </div>
    </header>
  )
}
